import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
import { DadosGerais, ValidacaoDadosGerais } from 'models/Viabilidade/DadosGerais'
import { TipoProjetoEnum } from 'models/Viabilidade/Enum/TipoProjetoEnum'
import { ModeloNegocioEnum } from 'models/Viabilidade/Enum/ModeloNegocioEnum'
import Grid from 'components/Grid'
import * as S from './index.style'
import { ElementType, useState } from 'react'
import { MascaraDecimal } from 'components/Mascara/Decimal'
import { InputBaseComponentProps } from '@material-ui/core/InputBase'
import { helperTextErroCampoOpcional } from 'helpers/Constantes/Mensagens'
import { LinhaProdutoEnum } from 'models/Viabilidade/Enum/LinhaProdutoEnum'

const CartaoDadosGerais: React.FC<{ dadosGerais: DadosGerais; dadosGeraisHandler: (novoValor: DadosGerais) => void }> = ({
  dadosGerais,
  dadosGeraisHandler
}) => {
  const [valores, setValores] = useState(dadosGerais)
  const [mensagensErro, setMensagensErro] = useState(new ValidacaoDadosGerais())
  const [areaPoligonoTerreno, setAreaPoligonoTerreno] = useState<string>()

  if (!areaPoligonoTerreno) {
    setAreaPoligonoTerreno(dadosGerais.areaTerrenoBruta)
  }

  const nomeViabilidadeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const state = replaceState(event) as DadosGerais
    state.nomeViabilidade = retirarCaracteresEspeciais(state.nomeViabilidade)
    setValores(state)
    dadosGeraisHandler(state)
  }

  const areaTerrenoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const state = replaceState(event) as DadosGerais
    state.areaTerrenoLiquida = calcularAreaLiquida(state.areaTerrenoBruta, state.areaTerrenoDescontar)
    setValores(state)
    dadosGeraisHandler(state)
  }

  const tipoProjetoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const state = replaceState(event) as DadosGerais
    state.numeroCondominio = '1'
    mensagensErro.numeroCondominio = ''

    setValores(state)
    dadosGeraisHandler(state)
    setMensagensErro(mensagensErro)
  }

  const camposHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const state = replaceState(event) as DadosGerais

    setValores(state)
    dadosGeraisHandler(state)
    setMensagensErro(mensagensErro)
  }

  const replaceState = (event: React.ChangeEvent<HTMLInputElement>): Record<string, unknown> => {
    const state = { ...valores } as Record<string, unknown>
    state[event.target.name] = event.target.value
    return state
  }

  const retirarCaracteresEspeciais = (valor: string): string => {
    return valor.replace(/([^\w\sà-úÀ-Ú-])/gi, '')
  }

  const calcularAreaLiquida = (areaTerrenoBruta: string, areaTerrenoDescontar: string): string => {
    const areaTerrenoDescontarNumerico = parseFloat(areaTerrenoDescontar) ? parseFloat(areaTerrenoDescontar) : 0
    let areaLiquidaCalculada = parseFloat(areaTerrenoBruta) - areaTerrenoDescontarNumerico
    areaLiquidaCalculada = areaLiquidaCalculada ? areaLiquidaCalculada : 0
    return areaLiquidaCalculada < 0 ? '0' : areaLiquidaCalculada.toString()
  }

  const validarAreaTerrenoBruta = () => {
    const erroAreaTerrenoBruta = mensagensErro.validarAreaTerrenoBruta(valores.areaTerrenoBruta, areaPoligonoTerreno as string)
    const validador = new ValidacaoDadosGerais(
      erroAreaTerrenoBruta,
      mensagensErro.areaTerrenoDescontar,
      mensagensErro.nomeViabilidade,
      mensagensErro.numeroCondominio,
      mensagensErro.tipoProjeto,
      mensagensErro.modeloNegocio,
      mensagensErro.linhaProduto
    )
    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarAreaTerrenoDescontar = () => {
    const erroAreaTerrenoDescontar = mensagensErro.validarAreaTerrenoDescontar(valores.areaTerrenoDescontar, valores.areaTerrenoBruta)
    const validador = new ValidacaoDadosGerais(
      mensagensErro.areaTerrenoBruta,
      erroAreaTerrenoDescontar,
      mensagensErro.nomeViabilidade,
      mensagensErro.numeroCondominio,
      mensagensErro.tipoProjeto,
      mensagensErro.modeloNegocio,
      mensagensErro.linhaProduto
    )
    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarNomeViabilidade = () => {
    const erroNomeViabilidade = mensagensErro.validarNomeViabilidade(valores.nomeViabilidade)
    const validador = new ValidacaoDadosGerais(
      mensagensErro.areaTerrenoBruta,
      mensagensErro.areaTerrenoDescontar,
      erroNomeViabilidade,
      mensagensErro.numeroCondominio,
      mensagensErro.tipoProjeto,
      mensagensErro.modeloNegocio,
      mensagensErro.linhaProduto
    )
    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarModeloNegocio = () => {
    const erroModeloNegocio = mensagensErro.validarModeloNegocio(valores.modeloNegocio)
    const validador = new ValidacaoDadosGerais(
      mensagensErro.areaTerrenoBruta,
      mensagensErro.areaTerrenoDescontar,
      mensagensErro.nomeViabilidade,
      mensagensErro.numeroCondominio,
      mensagensErro.tipoProjeto,
      erroModeloNegocio,
      mensagensErro.linhaProduto
    )
    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarTipoProjeto = () => {
    const erroTipoProjeto = mensagensErro.validarTipoProjeto(valores.tipoProjeto)
    const validador = new ValidacaoDadosGerais(
      mensagensErro.areaTerrenoBruta,
      mensagensErro.areaTerrenoDescontar,
      mensagensErro.nomeViabilidade,
      mensagensErro.numeroCondominio,
      erroTipoProjeto,
      mensagensErro.modeloNegocio,
      mensagensErro.linhaProduto
    )
    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarLinhaProduto = () => {
    const erroLinhaProduto = mensagensErro.validarLinhaProduto(valores.linhaProduto)
    const validador = new ValidacaoDadosGerais(
      mensagensErro.areaTerrenoBruta,
      mensagensErro.areaTerrenoDescontar,
      mensagensErro.nomeViabilidade,
      mensagensErro.numeroCondominio,
      mensagensErro.tipoProjeto,
      mensagensErro.modeloNegocio,
      erroLinhaProduto
    )
    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarCard = (validador: ValidacaoDadosGerais) => {
    const state = { ...valores } as DadosGerais

    state.valido = validador.validarTodosCampos(state)
    setValores(state)
    dadosGeraisHandler(state)
  }

  return (
    <S.Wrapper>
      <S.NomeSecao>Viabilidade</S.NomeSecao>
      <Grid orientacao="column" gridTemplateColumns="1.5fr repeat(3, 1fr)" gridGap="32px">
        <div>
          <S.Label>Nome da Viabilidade</S.Label>
          <TextField
            name="nomeViabilidade"
            data-cy="campoNomeViabilidade"
            value={valores.nomeViabilidade}
            fullWidth
            placeholder="Ex.: Viabilidade Testes - Casas 01"
            variant="outlined"
            size="small"
            onChange={nomeViabilidadeHandler}
            onBlur={validarNomeViabilidade}
            inputProps={{ maxLength: 100 }}
            error={mensagensErro.nomeViabilidade != ''}
            helperText={mensagensErro.nomeViabilidade}
          />
        </div>

        <div>
          <S.Label>Tipo de Projeto</S.Label>
          <TextField
            name="tipoProjeto"
            data-cy="campoTipoProjeto"
            value={valores.tipoProjeto}
            fullWidth
            variant="outlined"
            size="small"
            onChange={tipoProjetoHandler}
            onBlur={validarTipoProjeto}
            error={mensagensErro.tipoProjeto != ''}
            helperText={mensagensErro.tipoProjeto}
            select
          >
            <MenuItem value={TipoProjetoEnum.LoteamentoAberto} data-cy="tipoProjetoLoteamenteamentoAberto">
              Loteamento Aberto
            </MenuItem>
            <MenuItem value={TipoProjetoEnum.CondominioIncorporacao} data-cy="tipoProjetoCondominioIncorporacao">
              Condomínio Incorporação
            </MenuItem>
          </TextField>
        </div>

        <div>
          <S.Label>Linha de Produto</S.Label>
          <TextField
            name="linhaProduto"
            data-cy="campoLinhaProduto"
            value={valores.linhaProduto}
            fullWidth
            placeholder="Selecione"
            variant="outlined"
            size="small"
            onChange={camposHandler}
            onBlur={validarLinhaProduto}
            error={mensagensErro.linhaProduto != ''}
            helperText={mensagensErro.linhaProduto}
            select
          >
            {Object.entries(LinhaProdutoEnum).map(([chave, valor]) => (
              <MenuItem key={chave} value={valor} data-cy={`linhaProduto${chave}`}>
                {valor}
              </MenuItem>
            ))}
          </TextField>
        </div>

        {valores.tipoProjeto === TipoProjetoEnum.CondominioIncorporacao && (
          <div>
            <S.Label>Número de Condomínio</S.Label>
            <TextField
              name="numeroCondominio"
              data-cy="campoNumeroCondominio"
              value={valores.numeroCondominio}
              fullWidth
              placeholder="00"
              variant="outlined"
              size="small"
              disabled={true}
            />
          </div>
        )}

        {valores.tipoProjeto === TipoProjetoEnum.LoteamentoAberto && (
          <div>
            <S.Label>Modelo de Negócio</S.Label>
            <TextField
              name="modeloNegocio"
              data-cy="campoModeloNegocio"
              value={valores.modeloNegocio}
              fullWidth
              placeholder="Selecione"
              variant="outlined"
              size="small"
              onChange={camposHandler}
              onBlur={validarModeloNegocio}
              error={mensagensErro.modeloNegocio != ''}
              helperText={mensagensErro.modeloNegocio}
              select
            >
              <MenuItem value={ModeloNegocioEnum.ParceriaLoteadora} data-cy="modeloNegocioParceriaLoteadora">
                Parceria com Loteadora
              </MenuItem>
              <MenuItem value={ModeloNegocioEnum.MrvAdquirenteLote} data-cy="modeloNegocioMrvAdquirenteLote">
                MRV adquirente do Lote
              </MenuItem>
            </TextField>
          </div>
        )}
      </Grid>

      <S.Divisor></S.Divisor>

      <S.NomeSecao>Terreno</S.NomeSecao>
      <Grid orientacao="column" gridTemplateColumns="repeat(5, 1fr)" gridGap="32px">
        <div>
          <S.Label>Área do Terreno Bruta (m²)</S.Label>
          <TextField
            name="areaTerrenoBruta"
            data-cy="campoAreaTerrenoBruta"
            value={valores.areaTerrenoBruta}
            fullWidth
            placeholder="000.000.000,00"
            variant="outlined"
            size="small"
            onChange={areaTerrenoHandler}
            onBlur={validarAreaTerrenoBruta}
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            error={mensagensErro.areaTerrenoBruta != ''}
            helperText={mensagensErro.areaTerrenoBruta}
          />
        </div>
        <div>
          <S.Label>Área à Descontar (m²)</S.Label>
          <TextField
            name="areaTerrenoDescontar"
            data-cy="campoAreaTerrenoDescontar"
            value={valores.areaTerrenoDescontar}
            fullWidth
            placeholder="000.000.000,00"
            variant="outlined"
            size="small"
            onChange={areaTerrenoHandler}
            onBlur={validarAreaTerrenoDescontar}
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            error={mensagensErro.areaTerrenoDescontar != ''}
            helperText={helperTextErroCampoOpcional(mensagensErro.areaTerrenoDescontar)}
          />
        </div>
        <div>
          <S.Label>Área do Terreno Líquida (m²)</S.Label>
          <TextField
            name="areaTerrenoLiquida"
            data-cy="campoAreaTerrenoLiquida"
            disabled
            value={valores.areaTerrenoLiquida}
            fullWidth
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
          />
        </div>
        <div>
          <S.Label>Valor Moeda MRV Compra</S.Label>
          <TextField
            name="moedaMrvCompra"
            data-cy="campoMoedaMrvCompra"
            disabled
            value={valores.valorMoedaMrvCompra}
            fullWidth
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
          />
        </div>
        <div>
          <S.Label>Valor Moeda MRV Atual</S.Label>
          <TextField
            name="moedaMrvAtual"
            data-cy="campoMoedaMrvAtual"
            disabled
            value={valores.valorMoedaMrvAtual}
            fullWidth
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
          />
        </div>
      </Grid>
    </S.Wrapper>
  )
}

export default CartaoDadosGerais
